module.exports = __webpack_public_path__ + "static/media/video-fashion.83ee33b2.mp4";